import { motion } from 'framer-motion'

export default function TitleScreen({ onStart }) {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-pink-200 via-purple-200 to-blue-200 overflow-hidden relative">
      {/* Y2K Background Elements - キラキラ効果 */}
      <div className="absolute inset-0 overflow-hidden">
        {/* 浮遊するキラキラ */}
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute text-2xl"
            initial={{ 
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              opacity: 0,
              scale: 0
            }}
            animate={{
              y: [null, Math.random() * window.innerHeight],
              opacity: [0, 1, 0],
              scale: [0, 1, 0],
              rotate: [0, 360]
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
              ease: "easeInOut"
            }}
          >
            {['✨', '⭐', '💫', '🌟'][Math.floor(Math.random() * 4)]}
          </motion.div>
        ))}
        
        {/* グラデーションバブル */}
        <motion.div
          className="absolute w-96 h-96 rounded-full bg-gradient-to-br from-pink-300/40 to-purple-300/40 blur-3xl"
          animate={{
            x: [0, 100, 0],
            y: [0, 50, 0],
            scale: [1, 1.2, 1],
          }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
          style={{ top: '10%', left: '10%' }}
        />
        <motion.div
          className="absolute w-96 h-96 rounded-full bg-gradient-to-br from-blue-300/40 to-cyan-300/40 blur-3xl"
          animate={{
            x: [0, -100, 0],
            y: [0, 80, 0],
            scale: [1, 1.3, 1],
          }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
          style={{ bottom: '10%', right: '10%' }}
        />
        <motion.div
          className="absolute w-80 h-80 rounded-full bg-gradient-to-br from-yellow-300/30 to-pink-300/30 blur-3xl"
          animate={{
            x: [0, 60, 0],
            y: [0, -40, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
          style={{ top: '50%', left: '50%' }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8">
        <motion.div
          initial={{ opacity: 0, y: -50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, delay: 0.2, type: "spring" }}
        >
          <motion.h1
            className="font-display text-5xl md:text-7xl font-black mb-6 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent"
            animate={{
              backgroundPosition: ['0%', '100%'],
            }}
            style={{
              backgroundSize: '200%',
            }}
          >
            <span className="inline-block">限界チャレンジ1</span>
            <br />
            <span className="inline-block text-4xl md:text-6xl mt-2">✨ English ✨</span>
          </motion.h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.5, rotate: -180 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, delay: 0.8, type: "spring", stiffness: 200 }}
          className="mt-12"
        >
          <motion.button
            onClick={onStart}
            className="btn-neon px-12 py-5 text-xl font-black relative z-10"
            whileHover={{ scale: 1.1, rotate: [0, -5, 5, -5, 0] }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="relative z-10">✨ はじめる ✨</span>
          </motion.button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="mt-8"
        >
          <p className="text-purple-600 text-base md:text-lg font-bold drop-shadow-lg">
            💖 高校入試頻出表現を身に着けよう！ 💖
          </p>
        </motion.div>
      </div>
    </div>
  )
}
